import React, { useState } from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const ThemeSelector = () => {
  const { currentTheme, themes, changeTheme } = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="theme-selector-container" style={{ position: 'relative' }}>
      <button
        className="cyber-button"
        onClick={() => setIsOpen(!isOpen)}
        style={{ fontSize: '14px', padding: '8px 16px' }}
      >
        Theme: {themes[currentTheme]?.name}
      </button>
      
      {isOpen && (
        <div 
          className="theme-dropdown"
          style={{
            position: 'absolute',
            top: '100%',
            right: 0,
            zIndex: 1000,
            background: 'var(--card-bg)',
            border: '1px solid var(--card-border)',
            borderRadius: '8px',
            padding: '10px',
            minWidth: '200px',
            boxShadow: 'var(--glow-intense)',
            marginTop: '5px'
          }}
        >
          {Object.entries(themes).map(([key, theme]) => (
            <div
              key={key}
              className={`theme-option ${currentTheme === key ? 'active' : ''}`}
              onClick={() => {
                changeTheme(key);
                setIsOpen(false);
              }}
              style={{
                padding: '10px',
                cursor: 'pointer',
                borderRadius: '4px',
                marginBottom: '5px',
                border: currentTheme === key ? '1px solid var(--primary-accent)' : '1px solid transparent',
                backgroundColor: currentTheme === key ? 'rgba(0, 170, 255, 0.1)' : 'transparent',
                transition: 'var(--transition-standard)'
              }}
              onMouseEnter={(e) => {
                if (currentTheme !== key) {
                  e.target.style.backgroundColor = 'rgba(0, 170, 255, 0.05)';
                }
              }}
              onMouseLeave={(e) => {
                if (currentTheme !== key) {
                  e.target.style.backgroundColor = 'transparent';
                }
              }}
            >
              <div style={{ fontWeight: '600', color: 'var(--text-accent)' }}>
                {theme.name}
              </div>
              <div style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>
                {theme.description}
              </div>
            </div>
          ))}
        </div>
      )}
      
      {/* Click outside to close */}
      {isOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 999
          }}
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};

export default ThemeSelector;
